import { render } from "./OneCalc.vue?vue&type=template&id=3729a80a&scoped=true"
import script from "./OneCalc.vue?vue&type=script&lang=js"
export * from "./OneCalc.vue?vue&type=script&lang=js"

import "./OneCalc.vue?vue&type=style&index=0&id=3729a80a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3729a80a"]])

export default __exports__